(function () {
  'use strict';

  var ELITE_VARIANTS = [52930601091408, 52915119554896];
  var GIFT_VARIANTS = [
    53286442991952,
    53286443024720,
    53286443057488,
    53286443090256,
    53286443123024,
    53286443155792,
    53286443188560
  ];

  var syncing = false;
  var ourRequest = false;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  function addGifts(ids) {
    ourRequest = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: ids.map(function(id) { return { id: id, quantity: 1 }; }) })
    }).then(function(r) { ourRequest = false; return r; }).catch(function(e) { ourRequest = false; throw e; });
  }

  function removeGifts(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {};
    keys.forEach(function(k) { updates[k] = 0; });
    ourRequest = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(function(r) { ourRequest = false; return r; }).catch(function(e) { ourRequest = false; throw e; });
  }

  function syncGifts() {
    if (syncing || ourRequest) return;
    syncing = true;
    fetchCart().then(function(cart) {
      var items = cart.items || [];
      var hasElite = items.some(function(i) { return ELITE_VARIANTS.indexOf(i.variant_id) !== -1; });
      var giftLines = items.filter(function(i) { return GIFT_VARIANTS.indexOf(i.variant_id) !== -1; });

      if (hasElite) {
        var presentIds = giftLines.map(function(i) { return i.variant_id; });
        var missing = GIFT_VARIANTS.filter(function(id) { return presentIds.indexOf(id) === -1; });
        if (missing.length) {
          addGifts(missing).then(function() {
            syncing = false;
            if (window.location.pathname === '/cart' && !sessionStorage.getItem('tx_synced')) {
              sessionStorage.setItem('tx_synced', '1');
              window.location.href = '/cart';
            }
          }).catch(function() { syncing = false; });
        } else {
          syncing = false;
          tagGiftRows();
        }
      } else {
        var keys = giftLines.map(function(i) { return i.key; });
        if (keys.length) {
          removeGifts(keys).then(function() {
            syncing = false;
            if (window.location.pathname === '/cart' && !sessionStorage.getItem('tx_synced')) {
              sessionStorage.setItem('tx_synced', '1');
              window.location.href = '/cart';
            }
          }).catch(function() { syncing = false; });
        } else {
          syncing = false;
        }
      }
    }).catch(function() { syncing = false; });
  }

  function watchRemoveButtons() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[on\\:click*="onLineItemRemove"]');
      if (!btn) return;
      var row = btn.closest('tr.cart-items__table-row');
      var isGift = row && (row.classList.contains('tx-gift-row') || (function() {
        var pc = row.querySelector('.cart-items__price');
        return pc && pc.textContent.replace(/[\s\u00a0]/g,'') === '\u00a30.00';
      })());
      if (!isGift) {
        // Elite or unknown row being removed — sync quickly
        setTimeout(syncGifts, 600);
      }
    }, true);
  }

  function startCartPoller() {
    if (window.location.pathname !== '/cart') return;
    setInterval(function() {
      if (ourRequest || syncing) return;
      fetchCart().then(function(cart) {
        var items = cart.items || [];
        var hasElite = items.some(function(i) { return ELITE_VARIANTS.indexOf(i.variant_id) !== -1; });
        var giftLines = items.filter(function(i) { return GIFT_VARIANTS.indexOf(i.variant_id) !== -1; });
        if (!hasElite && giftLines.length) syncGifts();
      }).catch(function(){});
    }, 500);
  }

  function tagGiftRows() {
    setTimeout(function() {
      var rows = document.querySelectorAll('tr.cart-items__table-row');
      rows.forEach(function(row) {
        var isGift = false;
        row.querySelectorAll('.cart-items__variants dd').forEach(function(dd) {
          if (dd.textContent.trim() === 'Free with Elite') isGift = true;
        });
        if (!isGift) {
          var pc = row.querySelector('.cart-items__price');
          if (pc && pc.textContent.replace(/[\s\u00a0]/g, '') === '\u00a30.00') isGift = true;
        }
        if (isGift) {
          row.classList.add('tx-gift-row');
          row.style.order = '2';
        } else {
          row.classList.add('tx-elite-row');
          row.style.order = '1';
        }
      });
      var tbody = document.querySelector('.cart-items__table tbody');
      if (tbody) {
        tbody.style.display = 'flex';
        tbody.style.flexDirection = 'column';
        tbody.style.width = '100%';
      }
    }, 400);
  }

  function injectStyles() {
    if (document.getElementById('tx-gift-styles')) return;
    var s = document.createElement('style');
    s.id = 'tx-gift-styles';
    s.textContent = [
      'tr.tx-gift-row { opacity: 0.65; }',
      'tr.tx-gift-row .cart-items__media-container { max-width: 44px !important; }',
      'tr.tx-gift-row .cart-items__media-image { width: 44px !important; height: 44px !important; object-fit: contain !important; }',
      'tr.tx-gift-row .cart-items__title { font-size: 0.72rem !important; line-height: 1.3 !important; }',
      'tr.tx-gift-row .cart-items__variants dd { color: #82aab5 !important; font-size: 0.65rem !important; }',
      'tr.tx-gift-row td.cart-items__quantity { visibility: hidden !important; }',
      'tr.tx-gift-row .cart-items__remove { display: none !important; }',
      'tr.tx-gift-row td.cart-items__price { font-size: 0.7rem !important; }',
      'tr.tx-gift-row { padding-bottom: 2px !important; margin-bottom: 2px !important; }',
      's.compare-at-price { text-decoration: line-through !important; display: inline !important; opacity: 0.5; }'
    ].join('\n');
    document.head.appendChild(s);
  }

  var _fetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = (typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url)) || '';
    var p = _fetch.apply(this, args);
    if (!ourRequest && /\/cart\/(add|change|update|clear)\.js/.test(url)) {
      p.then(function() { setTimeout(syncGifts, 500); }).catch(function(){});
    }
    return p;
  };

  function init() {
    injectStyles();
    watchRemoveButtons();
    startCartPoller();
    var alreadySynced = sessionStorage.getItem('tx_synced');
    sessionStorage.removeItem('tx_synced');
    if (alreadySynced) {
      setTimeout(tagGiftRows, 400);
    } else {
      setTimeout(syncGifts, 600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
